import { Module } from "@/constants";
import { invoiceSpecificationsService } from "@/services/invoiceSpecifications";
import { useQuery } from "@tanstack/react-query";

export function useInvoiceSpecificationQuery(invoiceSpecificationId: string) {
  return useQuery({
    queryKey: [Module.InvoiceSpecifications, invoiceSpecificationId],
    queryFn: () =>
      invoiceSpecificationsService.getInvoiceSpecification(
        invoiceSpecificationId,
      ),
  });
}
